module.exports = __webpack_public_path__ + "static/media/0_2019_06_29.797e067c.jpg";